import { LinkVariant } from '@ampcore/adel-react'
import { UserStatus } from '../../types/UserStatus.enum'
import { ConditionalLinkProps } from '../Link/ConditionalLink'

export const APP_BAR_DEFAULT_LINKS: Omit<ConditionalLinkProps, 'userStatus'>[] =
  [
    {
      variant: LinkVariant.PRIMARY,
      name: 'Find an Advisor',
      url: 'https://www.ameripriseadvisors.com',
      className: 'u-sm-hidden u-md-hidden',
      displayFor: { mode: 'show', statuses: [UserStatus.PROSPECT] },
      target: '_blank'
    },
    {
      variant: LinkVariant.SECONDARY,
      name: 'Return to My Accounts',
      url: 'https://www.ameriprise.com/secure/overview',
      analyticsName: 'return-to-my-accounts',
      className: 'u-hidden u-lg-block',
      displayFor: { mode: 'show', statuses: [UserStatus.CLIENT_ACTIVE] }
    },
    {
      variant: LinkVariant.PRIMARY,
      name: 'Log Out',
      url: 'https://www.ameriprise.com/secure/logout',
      displayFor: { mode: 'show', statuses: [UserStatus.CLIENT_ACTIVE] }
    },
    {
      variant: LinkVariant.SECONDARY,
      name: 'Log In',
      url: 'https://www.ameriprise.com/client-login',
      displayFor: { mode: 'hide', statuses: [UserStatus.CLIENT_ACTIVE] }
    }
  ]
